/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import React from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import useSWR from "swr";
import { allImages } from "../../utils/contants";
import { FaCircleStop } from "react-icons/fa6";
import { FaCirclePlay } from "react-icons/fa6";
import OrderDetails from "../../components/OrderDetails";
import Rating from "@mui/material/Rating";
import arrowimg from "../../assets/images/arrowimg.png";
import ModalComponent from "components/ModalComponent";
import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
// Dashboard components

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import LoaderComponent from "components/Loader";
import { baseURL } from "utils/api";
import axios from "axios";
import TabComponent from "components/TabComponent";
import Select from "react-select";
import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import OrderTrackingLocationUI from "components/OrderLocationTrackingUI";
import ReturnRefundDetails from "components/Return-RefundOrderDetail";
function OrderReturnTracking() {
  const navigate = useNavigate();
  // fetch data swr
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);
  const [file, setFile] = useState("");


  // get random image to display in order table-:

  const randomIndex = Math.floor(Math.random() * allImages.length);

  // Get the random image URL
  const randomImageUrl = allImages[randomIndex];
  const [orderRefundList, setOrderRefundList] = useState([]);
  const fetchData = async (url) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/orders/getAllOrders?page=1&filter=refund&limit=10
      `);
      setOrderRefundList(response.data.data.orderDetails);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
  let data;
  useEffect(() => {
    data = fetchData();
  }, []);
  const RenderButtonCellReturn = (params) => {
    console.log(params,'3333')
    const [stoppedOrder, setStoppedOrder] = useState(params?.row?.stop);
    const handleStopOrder = (row) => {
      setStoppedOrder(true);
      axios.put(`${process.env.REACT_APP_BASE_URL}/shipping/startStopRefundReturn?orderId=${row.orderDetails.orderId}`,
      {
        stop:true 
      })
    };
    const handleContinueOrder = (row) => {
      setStoppedOrder(false);
      axios.put(`${process.env.REACT_APP_BASE_URL}/shipping/startStopRefundReturn?orderId=${row.orderDetails.orderId}`,
      {
        stop:false 
      })
    };
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
      setOpenModal(true);
    };
    const closeModal = () => {
      setOpenModal(false);
    };

    // continue order handler-:

    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const handleShowOrderDetails = () => {
      setShowOrderDetails(true);
    };
    const handleHideOrderDetails = () => {
      setShowOrderDetails(false);
    };
    const [orderLocationData, setOrderLocationData] = useState({});
    const [locationHistoryData, setLocationHistoryData] = useState([]);

    const fetchDataForMultiplePages = async (_id) => {
      try {
        // setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/shipping/getRefundReturnOrderLocation?orderId=${_id}`
        );

        const orderLocationData = response?.data?.orderLocation || {};
        const locationHistory = orderLocationData.locationHistory || [];

        setOrderLocationData(orderLocationData);
        setLocationHistoryData(locationHistory);
        // setUnpaid(locationHistory);
        // setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // setLoading(false);
      }
    };
    // continue order handler-:

    return (
      <>
        <div className="" style={{ marginLeft: "-20px" }}>
          <Tooltip title="Show Details">
            <IconButton>
              <MdOutlinePreview
                onClick={(e) => {
                  handleShowOrderDetails(params.row._id);
                  console.log(params, "PPPPPPPPPPPPPP"), e.stopPropagation();
                }}
                style={{ cursor: "pointer" }}
              />
            </IconButton>
          </Tooltip>

          {stoppedOrder ? (
            <Tooltip title="Continue">
              <IconButton>
                <FaCirclePlay
                  onClick={(e) => {
                    handleContinueOrder(params.row);
                    e.stopPropagation();
                  }}
                  className="text-green-400 text-xl"
                />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Stop">
              <IconButton>
                <FaCircleStop
                  onClick={(e) => {
                    handleStopOrder(params.row);
                    e.stopPropagation();
                  }}
                  className="text-red-400 text-xl"
                />
              </IconButton>
            </Tooltip>
          )}

          {/* </div> */}
          <Tooltip title="Track">
            <IconButton>
              <IoLocationOutline
                onClick={(e) => {
                  handleOpenModal();
                  e.stopPropagation();
                  fetchDataForMultiplePages(params.row._id);
                }}
                className="text-blue-400 cursor-pointer text-xl"
              />
            </IconButton>
          </Tooltip>

          <ModalComponent
            title={"Track Processing Orders"}
            open={openModal}
            handleClose={closeModal}
          >
           
            <OrderTrackingLocationUI locationHistoryData={locationHistoryData} orderLocationData={orderLocationData}/>
          </ModalComponent>
          <ModalComponent
            title={" Refund Details"}
            open={showOrderDetails}
            handleClose={handleHideOrderDetails}
          >
            {console.log(params.row,'EEEEEEEe')}
            <ReturnRefundDetails orderId={params.row._id} orderType={'refund'} />
          </ModalComponent>
        </div>
      </>
    );
  };
  const columns = [
    {
      field: "productName",
      headerName: "Product Name",
      width: "180",
    },
    {
      field: "productImage",
      headerName: "Image",
      width: 100,
      renderCell: (param) => {
        return (
          <img src={param.row.productImage} className="h-[7vh] w-[6vw] object-contain" alt="image_order" />
        );
      },
    },
    {
      field: "_id",
      headerName: "Order Details",
      width: 200,
    },
    {
      field: "storeId",
      headerName: "SkuId-store",
      width: 100,
    },
    {
      field: "userId",
      headerName: "User Id",
      width: 100,
    },
    {
      field: "yuan",
      headerName: "¥",
      width: 100,
    },
    {
      field: "unitPrice",
      headerName: "Unit Price",
      width: 100,
      // editable: true,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 100,
      // editable: true,
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      width: 100,
      // editable: true,
    },
    {
      field: "mode",
      headerName: "Mode",
      width: 100,
      // editable: true,
    },
    {
      field: "orderDate",
      headerName: "Order Date",
      width: 200,
      // editable: true,
    },
    {
      field: "orderStatus",
      headerName: "Order Status",
      width: 200,
      // editable: true,
    },
    {
      field: "refundDate",
      headerName: "Refund Date",
      width: 200,
      // editable: true,
    },

    // {
    //   field: "returndetails",
    //   headerName: "Refund Details",
    //   width: 200,
    //   // editable: true,
    // },
    // {
    //     field: "feedback",
    //     headerName: "Feedback",
    //     width: 200,
    //     // editable: true,
    // },

    {
      field: "feedBack",
      headerName: "Feedback",
      width: 200,
      // editable: true,
      renderCell: (param) => {
        return (
          <>
            <div className="flex flex-col gap-2">
              <Rating name="read-only" value={param.row.feedBack} readOnly />
              <span>Great Product</span>
            </div>
          </>
        );
      },
    },

    // {
    //   field: "action",
    //   headerName: "Action",
    //   description: "This column has a value getter and is not sortable.",
    //   sortable: false,
    //   width: 180,
    //   renderCell: (param) => {
    //     const detailsObj = { ...param.row };

    //     return (
    //       <>
    //         <div style={{ display: "flex", gap: "6px" }}>
    //           <Tooltip
    //             onClick={() => navigate("/ViewDetails", { state: detailsObj })}
    //             title="view"
    //           >
    //             <IconButton>
    //               <MdOutlinePreview style={{ cursor: "pointer" }} />
    //             </IconButton>
    //           </Tooltip>
    //         </div>
    //       </>
    //     );
    //   },
    //   valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    // },

    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      // renderCell: (param) => {
      //   const detailsObj = { ...param.row };

      //   const handlePreviewClick = () => {
      //     navigate("/ViewDetails", { state: detailsObj });
      //   };

      //   const [stoppedOrder, setStoppedOrder] = useState(null);
      //   const handleStopOrder = (row) => {
      //     setStoppedOrder(row);
      //   };
      //   // continue order handler-:
      //   const handleContinueOrder = () => {
      //     setStoppedOrder(null);
      //   };

      //   const handleStopClick = (e) => {
      //     handleStopOrder(param.row);
      //     e.stopPropagation();
      //   };
      //   const [openModal, setOpenModal] = useState(false);
      //   const handleOpenModal = () => {
      //     setOpenModal(true);
      //   };
      //   const closeModal = () => {
      //     setOpenModal(false);
      //   };


      //   const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
      //     [`&.${stepConnectorClasses.alternativeLabel}`]: {
      //       top: 22,
      //     },
      //     [`&.${stepConnectorClasses.active}`]: {
      //       [`& .${stepConnectorClasses.line}`]: {
      //         backgroundImage:
      //           "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
      //       },
      //     },
      //     [`&.${stepConnectorClasses.completed}`]: {
      //       [`& .${stepConnectorClasses.line}`]: {
      //         backgroundImage:
      //           "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
      //       },
      //     },
      //     [`& .${stepConnectorClasses.line}`]: {
      //       height: 3,
      //       border: 0,
      //       backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
      //       borderRadius: 1,
      //     },
      //   }));

      //   const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
      //     backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
      //     zIndex: 1,
      //     color: "#fff",
      //     width: 50,
      //     height: 50,
      //     display: "flex",
      //     borderRadius: "50%",
      //     justifyContent: "center",
      //     alignItems: "center",
      //     ...(ownerState.active && {
      //       backgroundImage: "linear-gradient(136deg, rgb(0, 100, 0) 0%, rgb(0, 100, 0) 100%)",
      //       boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
      //     }),
      //     ...(ownerState.completed && {
      //       backgroundImage: "linear-gradient(136deg, rgb(0, 100, 0) 0%, rgb(0, 100, 0) 100%)",
      //     }),
      //   }));

      //   function ColorlibStepIcon(props) {
      //     const { active, completed, className } = props;

      //     const icons = {
      //       1: <AssignmentReturnIcon />,
      //       2: <KeyboardReturnIcon />,
      //       3: <CurrencyExchangeIcon />,
      //     };

      //     return (
      //       <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      //         {icons[String(props.icon)]}
      //       </ColorlibStepIconRoot>
      //     );
      //   }

      //   const steps = ["Return", "Refund", "Exchange"];

      //   return (
      //     <div style={{ display: "flex", gap: "6px" }}>
      //       <Tooltip title="View">
      //         <IconButton onClick={handlePreviewClick}>
      //           <MdOutlinePreview style={{ cursor: "pointer" }} />
      //         </IconButton>
      //       </Tooltip>

      //       {stoppedOrder?.id === param.row.id ? (
      //         <Tooltip title="Continue">
      //           <IconButton>
      //             <FaCirclePlay
      //               onClick={(e) => {
      //                 handleContinueOrder();
      //                 e.stopPropagation();
      //               }}
      //               className="text-green-400 text-xl"
      //             />
      //           </IconButton>
      //         </Tooltip>
      //       ) : (
      //         <Tooltip title="Stop">
      //           <IconButton>
      //             <FaCircleStop
      //               onClick={(e) => {
      //                 handleStopOrder(param.row);
      //                 e.stopPropagation();
      //               }}
      //               className="text-red-400 text-xl"
      //             />
      //           </IconButton>
      //         </Tooltip>
      //       )}
      //       <Tooltip title="Track">
      //         <IconButton>
      //           <IoLocationOutline
      //             onClick={(e) => {
      //               handleOpenModal();
      //               e.stopPropagation();
      //             }}
      //             className="text-blue-400 cursor-pointer text-xl"
      //           />
      //         </IconButton>
      //       </Tooltip>
      //       <ModalComponent title={"Track Return Orders"} open={openModal} handleClose={closeModal}>
      //         <Stack sx={{ width: "1000px" }} spacing={4}>
      //           <Stepper alternativeLabel activeStep={2} connector={<ColorlibConnector />}>
      //             {steps.map((label) => (
      //               <Step key={label}>
      //                 <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
      //               </Step>
      //             ))}
      //           </Stepper>
      //         </Stack>
      //       </ModalComponent>
      //     </div>
      //   );
      // },
      renderCell: RenderButtonCellReturn,
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!orderRefundList && <LoaderComponent open={true} />}

      <div className="flex  gap-4" style={{ justifyContent: "flex-end", marginRight:"20px" }}>
        <Link to="/ordertracking">
          <button
            style={{ background: "maroon" }}
            className={`border-none cursor-pointer  font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
          >
            Return Tracking
          </button>
        </Link>

        <Link to="/refundtracking">
          <button
            style={{ background: "green" }}
            className={`border-none cursor-pointer  font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
          >
            Refund Tracking
          </button>
        </Link>

        {/* <Link to="/exchangetracking">
          <button
            style={{ background: "blue" }}
            className={`border-none  cursor-pointer font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
          >
            Exchange Tracking
          </button>
        </Link> */}
      </div>
      <Box sx={{ height: 550, width: "100%", background: "white", marginTop: "1%" }}>
        {console.log(orderRefundList, 'OrderRefund')}
        <DataGrid
          rows={orderRefundList ? orderRefundList : []}
          columns={columns}
          editMode="row"
          checkboxSelection={true}
          // rowModesModel={rowModesModel}
          // onRowModesModelChange={handleRowModesModelChange}
          // onRowEditStop={handleRowEditStop}
          // processRowUpdate={processRowUpdate}
          // onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
          experimentalFeatures={{ newEditingApi: true }}
          // slots={{
          //   toolbar: EditToolbar,
          // }}
          // slotProps={{
          //   toolbar: { setRows, setRowModesModel },
          // }}
          getRowId={(row) => row?._id}
          />

      </Box>

      <Footer />
    </DashboardLayout>
  );
}

export default OrderReturnTracking;
